import { Component } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { GoogleAuthProvider } from '@firebase/auth';
import { Store } from '@ngrx/store';
import { AuthActions } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';

export interface FireAuthRes {
  operationType: string;
  credential: {
    idToken: string;
    accessToken: string;
    pendingToken: string;
    providerId: string;
    signInMethod: string;
  };
  additionalUserInfo: {
    isNewUser: boolean;
    providerId: string;
    profile: {
      name: string;
      granted_scopes: string;
      id: string;
      verified_email: boolean;
      given_name: string;
      hd: string;
      family_name: string;
      email: string;
      picture: string;
    };
  };
  user: {
    uid: string;
    email: string;
    emailVerified: boolean;
    displayName: string;
    isAnonymous: boolean;
    photoURL: string;
    providerData: [
      {
        providerId: string;
        uid: string;
        displayName: string;
        email: string;
        phoneNumber: string;
        photoURL: string;
      }
    ];
    stsTokenManager: {
      refreshToken: string;
      accessToken: string;
      expirationTime: string;
    };
    createdAt: string;
    lastLoginAt: string;
    apiKey: string;
    appName: Array<string>;
  };
}

@Component({
  selector: 'app-firebase-auth',
  standalone: true,
  imports: [AngularSvgIconModule],
  templateUrl: './firebase-auth.component.html',
  styleUrl: './firebase-auth.component.scss',
})
export class FirebaseAuthComponent {
  fireAuthInfo!: FireAuthRes;

  constructor(private store: Store, private angularFireAuth: AngularFireAuth) {}

  async initializeGoogleSignIn() {
    const credential = (await this.angularFireAuth.signInWithPopup(new GoogleAuthProvider())) as any;
    this.fireAuthInfo = credential;
    this.store.dispatch(AuthActions.loginWithGoogle({ idToken: this.fireAuthInfo.credential.idToken || '' }));
  }
}
